import React, { useEffect, useRef, useState } from "react";
import {
	getColorByNumber,
	partiallyHideHash,
	pxToRem,
	toNumberFixed,
} from "@/util/common";
import { createUseStyles } from "react-jss";
import useCustomStyles from "@/hooks/useCustomStyles";
import { Button, Grid, Skeleton, Collapse, Toast } from "antd-mobile";
import useCenterPopup from "@/hooks/useCenterPopup";
import PlayerAddress from "./PlayerAddress";
import Remark from "./Remark";
import { isArray, isEmpty, isString } from "lodash";
import useRouter from "@/hooks/useRouter";
import { AppDispatch, RootState } from "@/redux/store";
import { useDispatch, useSelector } from "react-redux";
import useCustomTranslation from "@/hooks/useTranslation";
import { DownFill } from "antd-mobile-icons";
import { setUserManage } from "@/redux/reducers/manageUser";
import usePopup from "@/hooks/usePopup";
import { showGlobalLoading } from "../globalLoading";
import API from "@/api";
import ManageRights from "@/pages/ManageMembers/comp/ManageRights";
import Manage from "@/pages/ManageMembers/comp/Manage";
import { isDef } from "@/util/validate";

const TinyChens: React.FC<{
	membersData: Record<string, any>[];
	isOperate?: boolean;
	profit: string;
}> = ({ membersData, isOperate = true, profit }) => {
	const classes = useStyles();
	const useClasses = useCustomStyles();
	const { t } = useCustomTranslation();
	const { userInfo, isAdminType } = useSelector(
		(state: RootState) => state.auth
	);
	const PlayerAddressPopup = useCenterPopup();
	const RemarkPopup = useCenterPopup();
	const { customNavigate } = useRouter();
	const [memberActiveKey, setMemberActiveKey] = useState<string[]>([]);
	const dispatch: AppDispatch = useDispatch();
	const RightsPopup = usePopup();
	const ManagePopup = usePopup();
	const userManage = useSelector(
		(state: RootState) => state.manageUser.userManage
	);
	const [list, setList] = useState<any[]>([]);
	const [operatedData, setOperatedData] = useState<any>({});
	const dataRemark = useRef<any>({});

	useEffect(() => {
		return () => {
			dispatch(setUserManage({}));
		};
	}, []);

	useEffect(() => {
		setList(membersData);
	}, [membersData]);

	const formatProfit = (data: Record<string, any>) => {
		const rusult = getColorByNumber(data.earning);
		if (rusult === "win") {
			return "+" + toNumberFixed(data.earning, 2);
		} else if (rusult === "lose") {
			return toNumberFixed(data.earning, 2);
		}
		return "0";
	};

	const addAsAdministrator = (data: any) => {
		setOperatedData(data);
		dispatch(setUserManage(data));
		RightsPopup.showPopup();
	};

	const removeAdministrator = async (data: any) => {
		const result = await userAgentInviteRoleHandle({
			id: data.uid,
			remove: 1,
		});
		if (isArray(result)) {
			updateItemRoleMap(data, null);
		}
	};

	const managePermissions = (data: any) => {
		setOperatedData(data);
		ManagePopup.showPopup();
	};

	const onSubmitAddAdmin = async (dataTights: string[], data: any) => {
		if (isEmpty(userManage)) {
			return Toast.show({
				content: t("PSelectAddressMembers"),
				position: "top",
			});
		}
		const params: any = {
			id: userManage.uid,
		};
		let roleMap: any = {
			look: 1,
		};
		for (let index = 0; index < dataTights.length; index++) {
			const element = dataTights[index];
			if (!isEmpty(element)) {
				roleMap[element] = 1;
			}
		}
		params["agentRole"] = JSON.stringify(roleMap);
		const result = await userAgentInviteRoleHandle(params);
		if (isArray(result)) {
			updateItemRoleMap(data, roleMap);
		}
	};

	const onSubmitUpdatePermissions = async (params: {}, data: any) => {
		let result = await userAgentInviteRoleHandle(params);
		if (isArray(result)) {
			const { agentRole: roleMap } = result[0];
			updateItemRoleMap(data, JSON.parse(roleMap));
		}
	};

	const updateItemRoleMap = (originalData: any, roleMap: any) => {
		setList((prevList) =>
			prevList.map((item) =>
				item.uid === originalData.uid
					? { ...item, roleMap: roleMap }
					: item
			)
		);
	};

	// 新增[uid/下级用户uid roleMap/权限] 修改[id/roleMap] 删除[id/remove=1]
	const userAgentInviteRoleHandle = async (params: Record<string, any>) => {
		const { showLoading, hideLoading } = showGlobalLoading();
		try {
			showLoading();
			const result: any = await API.members.postUserAgentInviteRole(
				params
			);
			if (result?.code === 0) {
				Toast.show({
					content: params.agentRole
						? t("UpdateCompleted")
						: t("DeleteCompleted"),
					position: "top",
				});
				return [params, result.content?.data];
				//	postUserAgentManagerListHandle();
			}
		} catch (error) {
			console.log("---postUserAgentInviteRole--:", error);
		} finally {
			hideLoading();
		}
	};

	const renderAdminTopbar = (data: any) => {
		if (isDef(data.roleMap)) {
			return (
				<div className={classes.adminBox}>
					<Button
						className={classes.adminButton}
						block
						shape="rounded"
						fill="outline"
						onClick={() => managePermissions(data)}
					>
						{t("AdministrativePermissions")}
					</Button>
					<Button
						className={classes.adminButton}
						block
						shape="rounded"
						fill="outline"
						style={{
							"--text-color": "#FF6161",
							borderColor: "#FF6161",
						}}
						onClick={() => removeAdministrator(data)}
					>
						{t("RemoveAdministrator")}
					</Button>
				</div>
			);
		}
		return (
			<div
				className={classes.adminBox}
				style={{ justifyContent: "end" }}
				onClick={() => addAsAdministrator(data)}
			>
				<Button className={classes.adminButton}>
					{t("AddAsAdministrator")}
				</Button>
			</div>
		);
	};

	const renderOperationToolbar = (data: Record<string, any>) => {
		const buttonsData = [
			{
				name: t("Remark"),
				key: "remark",
			},
			{
				name: t("Gift"),
				key: "gift",
			},
			{
				name: t("GameRecord"),
				key: "game",
			},
			{
				name: t("DepositRecord"),
				key: "deposit",
			},
		];

		let settingData: Record<string, any> = {};
		const setting = data.setting;
		if (!isEmpty(setting) && setting) {
			settingData = JSON.parse(setting);
		}
		const getWaterPlanNameHandle = () => {
			let result = t("Default");
			const waterPlan = userInfo?.waterPlan || {};
			let indexValue = 1;
			if (!isEmpty(waterPlan)) {
				for (const key in waterPlan) {
					if (key === settingData.time) {
						result = t("Plan") + " " + indexValue;
					}
					indexValue += 1;
				}
			}
			return result;
		};

		const menuLinkHandle = (key: string) => {
			switch (key) {
				case "remark":
					dataRemark.current = data;
					RemarkPopup.showPopup();
					break;
				case "gift":
					dataRemark.current = data;
					PlayerAddressPopup.showPopup();
					break;
				case "game": {
					const outerParams = {
						nickname: data["nickname"],
						walletAddress: data["walletAddress"],
						inviteRemake: data["inviteRemake"],
						cover: isString(data["cover"])
							? encodeURIComponent(data["cover"])
							: null,
					};
					customNavigate(
						"/personnal-game-records" +
							"/" +
							data["uid"] +
							"/" +
							JSON.stringify(outerParams)
					);
					break;
				}
				case "deposit": {
					const outerParams = {
						nickname: data["nickname"],
						walletAddress: data["walletAddress"],
						inviteRemake: data["inviteRemake"],
						cover: isString(data["cover"])
							? encodeURIComponent(data["cover"])
							: null,
					};
					customNavigate(
						"/personnal-records" +
							"/" +
							data["uid"] +
							"/" +
							JSON.stringify(outerParams)
					);
					break;
				}
			}
		};

		return (
			<div className={classes.buttonsWrap}>
				<Grid columns={1} gap={[15, 8]}>
					{/* <Grid.Item>
						<Button
							className={classes.scheme}
							onClick={() => {
								const params: any = {
									uid: data.uid,
								};
								const idDefault =
									getWaterPlanNameHandle() !== t("Default");
								if (
									!isEmpty(settingData) &&
									settingData &&
									idDefault
								) {
									params["time"] = settingData.time;
								}
								customNavigate(
									"/manage-plan?user=" +
										JSON.stringify(params)
								);
							}}
							block
							shape="rounded"
							fill="outline"
							style={{
								fontSize: pxToRem(14),
								fontWeight: "400",
								"--text-color": "#82E8FF",
								"--background-color": "#1E212B",
								"--border-color": "#2F3A62",
							}}
						>
							{getWaterPlanNameHandle()}
						</Button>
					</Grid.Item> */}
					{buttonsData.map((item, index) => {
						return (
							<Grid.Item key={index}>
								<Button
									onClick={() => menuLinkHandle(item.key)}
									block
									shape="rounded"
									fill="outline"
									style={{
										fontSize: pxToRem(14),
										fontWeight: "400",
										"--text-color": "#82E8FF",
										"--background-color": "transparent",
										"--border-color": "#4C66C7",
									}}
								>
									{item.name}
								</Button>
							</Grid.Item>
						);
					})}
				</Grid>
			</div>
		);
	};

	return (
		<div className={classes.listContainer}>
			<Collapse
				arrow={<DownFill fontSize={pxToRem(12)} color="#B299FF" />}
				onChange={(keys) => {
					setMemberActiveKey(keys);
				}}
			>
				{list.map((data, index) => {
					const showAdminTopBar = !isAdminType;
					return (
						<Collapse.Panel
							className={
								memberActiveKey.indexOf(index + "") >= 0
									? "active"
									: ""
							}
							key={index + ""}
							title={
								<div className={classes.head}>
									<div className="l">
										<span>{data.nickname}</span>
									</div>
									<div className="r">
										<span>
											{t("Balance")}:
											<em
												style={{
													color: "#fff",
													marginLeft: "3px",
												}}
											>
												{toNumberFixed(data.balance, 2)}
											</em>
										</span>
										<span>
											{profit}:
											<em
												style={{
													color: "#8BFF78",
													marginLeft: "3px",
												}}
											>
												{formatProfit(data)}
											</em>
										</span>
									</div>
								</div>
							}
						>
							<div className={`${classes.tinyChenWrap}`}>
								{showAdminTopBar
									? renderAdminTopbar(data)
									: null}
								<div style={{ padding: `0 ${pxToRem(20)}` }}>
									<Grid columns={2} gap={[0, 16]}>
										<Grid.Item>
											<dl
												className={useClasses.dlWrap}
												style={
													showAdminTopBar
														? { paddingTop: 0 }
														: undefined
												}
											>
												<dt>{t("Address")}</dt>
												{!isEmpty(data) ? (
													<dd>
														{partiallyHideHash(
															data.walletAddress
														)}
													</dd>
												) : (
													<Skeleton
														animated
														style={{
															height: pxToRem(24),
															width: "80%",
														}}
													/>
												)}
											</dl>
										</Grid.Item>
										<Grid.Item>
											<dl
												className={useClasses.dlWrap}
												style={
													showAdminTopBar
														? { paddingTop: 0 }
														: undefined
												}
											>
												<dt>{t("Balance")}</dt>
												{!isEmpty(data) ? (
													<dd>
														{toNumberFixed(
															data.balance,
															2
														)}
													</dd>
												) : (
													<Skeleton
														animated
														style={{
															height: pxToRem(24),
															width: "80%",
														}}
													/>
												)}
											</dl>
										</Grid.Item>
										<Grid.Item>
											<dl className={useClasses.dlWrap}>
												<dt>{t("EffectiveWaget")}</dt>
												{!isEmpty(data) ? (
													<dd>
														{toNumberFixed(
															data.effective,
															2
														)}
													</dd>
												) : (
													<Skeleton
														animated
														style={{
															height: pxToRem(24),
															width: "80%",
														}}
													/>
												)}
											</dl>
										</Grid.Item>
										<Grid.Item>
											<dl className={useClasses.dlWrap}>
												<dt>{profit}</dt>
												{!isEmpty(data) ? (
													<dd
														style={{
															color: "#8BFF78",
														}}
													>
														{formatProfit(data)}
													</dd>
												) : (
													<Skeleton
														animated
														style={{
															height: pxToRem(24),
															width: "80%",
														}}
													/>
												)}
											</dl>
										</Grid.Item>
										<Grid.Item>
											<dl className={useClasses.dlWrap}>
												<dt>{t("FinalWagetTime")}</dt>
												{!isEmpty(data) ? (
													<dd className="tinydd">
														{data.finalTime || "-"}
													</dd>
												) : (
													<Skeleton
														animated
														style={{
															height: pxToRem(24),
															width: "80%",
														}}
													/>
												)}
											</dl>
										</Grid.Item>
										<Grid.Item>
											<dl className={useClasses.dlWrap}>
												<dt>{t("FirstWagetTime")}</dt>
												{!isEmpty(data) ? (
													<dd className="tinydd">
														{data.firstTime || "-"}
													</dd>
												) : (
													<Skeleton
														animated
														style={{
															height: pxToRem(24),
															width: "80%",
														}}
													/>
												)}
											</dl>
										</Grid.Item>
										<Grid.Item>
											<dl className={useClasses.dlWrap}>
												<dt>{t("SignTime")}</dt>
												{!isEmpty(data) ? (
													<dd className="tinydd">
														{data.createTime || "-"}
													</dd>
												) : (
													<Skeleton
														animated
														style={{
															height: pxToRem(24),
															width: "80%",
														}}
													/>
												)}
											</dl>
										</Grid.Item>
										<Grid.Item>
											<dl className={useClasses.dlWrap}>
												<dt>{t("LastLoginTime")}</dt>
												{!isEmpty(data) ? (
													<dd className="tinydd">
														{data.lastOnlineTime ||
															"-"}
													</dd>
												) : (
													<Skeleton
														animated
														style={{
															height: pxToRem(24),
															width: "80%",
														}}
													/>
												)}
											</dl>
										</Grid.Item>
										<Grid.Item>
											<dl className={useClasses.dlWrap}>
												<dt>
													{t(
														"MonthlyTotalReturnWater"
													)}
												</dt>
												{!isEmpty(data) ? (
													<dd className="win">
														{data.monthReturnWater ||
															"-"}
													</dd>
												) : (
													<Skeleton
														animated
														style={{
															height: pxToRem(24),
															width: "80%",
														}}
													/>
												)}
											</dl>
										</Grid.Item>
										<Grid.Item>
											<dl className={useClasses.dlWrap}>
												<dt>{t("Remark")}</dt>
												{!isEmpty(data) ? (
													<dd className="tinydd">
														{data.inviteRemake ||
															"-"}
													</dd>
												) : (
													<Skeleton
														animated
														style={{
															height: pxToRem(24),
															width: "80%",
														}}
													/>
												)}
											</dl>
										</Grid.Item>
									</Grid>
								</div>
								{isOperate && renderOperationToolbar(data)}
							</div>
						</Collapse.Panel>
					);
				})}
			</Collapse>
			<PlayerAddressPopup.PopupComp
				visible={PlayerAddressPopup.visiblePopup}
				onClose={PlayerAddressPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					PlayerAddressPopup.closePopup();
				}}
				className="centerPopupAfoot"
				style={{ "--max-width": "100vw" }}
			>
				<PlayerAddress
					onVisiblePopup={PlayerAddressPopup.closePopup}
					data={dataRemark.current}
				/>
			</PlayerAddressPopup.PopupComp>
			<RemarkPopup.PopupComp
				visible={RemarkPopup.visiblePopup}
				onClose={RemarkPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					RemarkPopup.closePopup();
				}}
				className="centerPopupAfoot"
				style={{ "--max-width": "100vw" }}
			>
				<Remark
					onVisiblePopup={RemarkPopup.closePopup}
					data={dataRemark.current}
				/>
			</RemarkPopup.PopupComp>

			<ManagePopup.PopupComp
				visible={ManagePopup.visiblePopup}
				onClose={ManagePopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					ManagePopup.closePopup();
				}}
			>
				<Manage
					onVisiblePopup={ManagePopup.closePopup}
					agentRoleData={
						isDef(operatedData?.roleMap)
							? {
									id: operatedData.uid,
									data: operatedData.roleMap,
							  }
							: {}
					}
					onSubmit={(params) =>
						onSubmitUpdatePermissions(params, operatedData)
					}
				/>
			</ManagePopup.PopupComp>

			<RightsPopup.PopupComp
				visible={RightsPopup.visiblePopup}
				onClose={RightsPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					RightsPopup.closePopup();
				}}
			>
				<ManageRights
					onVisiblePopup={RightsPopup.closePopup}
					onSubmit={(params) =>
						onSubmitAddAdmin(params, operatedData)
					}
				/>
			</RightsPopup.PopupComp>
		</div>
	);
};

export default TinyChens;

const useStyles = createUseStyles({
	listContainer: {
		// backgroundColor: 'red',
		"& .adm-list": {
			padding: 0,
			border: "none",
		},
		"& .adm-list-body": {
			backgroundColor: "transparent",
			border: "none",
		},
		"& .adm-collapse-panel-content": {
			marginBottom: pxToRem(11),
		},
		"& .adm-list-item-content": {
			borderTop: "none",
			padding: 0,
		},
		"& .adm-list-item-content-main": {
			padding: 0,
		},
		"& .adm-list-item": {
			padding: 0,
			backgroundColor: "transparent",
		},
		"& .adm-collapse-panel-header": {
			borderRadius: pxToRem(20),
			overflow: "hidden",
			background: "linear-gradient(#181B24, #232C48)",
			border: "1px solid #3A375D",
			transition: "all 0.6s",
			paddingRight: pxToRem(14),
		},
		"& .active": {
			borderBottomLeftRadius: 0,
			borderBottomRightRadius: 0,
		},
	},
	head: {
		display: "flex",
		alignItems: "center",
		// justifyContent: 'space-between',
		height: pxToRem(50),
		padding: {
			left: pxToRem(18),
			right: pxToRem(8),
		},
		"& .l": {
			flex: "0 1 auto",
			overflow: "hidden",
			display: "flex",
			alignItems: "center",
			fontSize: pxToRem(18),
			fontWeight: "700",
			color: "#FFFFFF",
			"& >span": {
				paddingLeft: pxToRem(4),
				whiteSpace: "nowrap",
				textOverflow: "ellipsis",
				overflow: "hidden",
			},
		},
		"& .r": {
			flex: 1,
			overflow: "hidden",
			width: 0,
			display: "flex",
			flexDirection: "column",
			fontSize: pxToRem(13),
			fontWeight: "500",
			color: "#868FA8",
			"& span": {
				whiteSpace: "nowrap",
				textOverflow: "ellipsis",
				overflow: "hidden",
				textAlign: "right",
			},
		},
	},
	tinyChenWrap: {
		border: "1px solid #3A375D",
		borderTop: "none",
		borderBottomLeftRadius: pxToRem(20),
		borderBottomRightRadius: pxToRem(20),
		overflow: "hidden",
		// marginBottom: pxToRem(10),
		background: "linear-gradient(156deg, #181B24 5.2%, #232C48 97.46%)",
	},
	buttonsWrap: {
		padding: {
			top: pxToRem(18),
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(24),
		},
	},
	scheme: {
		position: "relative",
		"&::after": {
			content: '""',
			position: "absolute",
			top: "50%",
			right: pxToRem(22),
			transform: "translate(0, -50%)",
			height: pxToRem(8),
			width: pxToRem(4),
			backgroundRepeat: "no-repeat",
			backgroundSize: "100% 100%",
			backgroundImage: `url(${require("@/assets/images/icons/arrow_right.png")})`,
			zIndex: 1,
		},
	},
	adminBox: {
		display: "flex",
		justifyContent: "space-between",
		padding: `${pxToRem(6)} ${pxToRem(7)}`,
	},
	adminButton: {
		height: pxToRem(25),
		width: pxToRem(103),
		borderRadius: pxToRem(12.5),
		"--text-color": "#82E8FF",
		backgroundColor: "transparent",
		borderColor: "#2F3A62",
		fontSize: pxToRem(13),
		fontWeight: 500,
		padding: 0,
	},
});
